<template>
  <div
    v-loading="isLoading"
    class="editor-layout editor-theme-sandy"
  >
    <div v-if="error">
      <ElResult
        icon="error"
        :title="error.toString()"
        subTitle="Пожалуйста, проверьте подключение к интернету и попробуйте снова"
      >
        <template
          v-if="visibleRepeatBtn"
          #extra
        >
          <ActionButton
            type="primary"
            @click="emit('repeat')"
          >
            Повторить запрос
          </ActionButton>
        </template>
      </ElResult>
    </div>

    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import { ElResult, vLoading } from 'element-plus'
import ActionButton from '@/components/basic/ActionButton/ActionButton.vue'


defineProps<{
  isLoading: boolean
  error: unknown
  visibleRepeatBtn: boolean
}>()

const emit = defineEmits<{
  (e: 'repeat'): void
}>()
</script>

<style scoped>
.editor-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: var(--ps-editor-bg);
  border: 1px solid var(--el-color-primary);
}
</style>
